import type { Portfolios } from '@/hooks/portfolio/usePortfolio';

export const getDefaultPortfolioId = (
  portfolioId: string | null,
  portfolios: Portfolios
) => {
  const hasOnlyOnePortfolio = portfolios.length === 1;
  const portfolioExistInPortfolios = portfolios.some(
    (portfolio) => portfolio.id === portfolioId
  );

  if (hasOnlyOnePortfolio) {
    return portfolios[0].id;
  }

  if (portfolioExistInPortfolios) {
    return portfolioId;
  }

  return null;
};
